import { NgModule } from '@angular/core';
import { UserDataByKeyPipe } from './user-data-by-key.pipe';

@NgModule({
    declarations: [UserDataByKeyPipe],
    exports: [UserDataByKeyPipe],
})
export class UserDataByKeyPipeModule {}
